// extracted by mini-css-extract-plugin
module.exports = {"headerTitle":"HeaderTitle_headerTitle__UlIZH","headerPart":"HeaderTitle_headerPart__295Pm"};